import {
  SET_CLASS_USER_SCHOOL,
  SET_CLASS_USER_LEVEL,
  SET_CLASS_USER_FACULT
} from '@/store/mutation-types'

const changeSearchClassUserSchool = ({commit, dispatch}, payload) => {
  commit(SET_CLASS_USER_SCHOOL, payload)
}
const changeSearchClassUserLevel = ({commit, dispatch}, payload) => {
  commit(SET_CLASS_USER_LEVEL, payload)
}
const changeSearchClassUserFacult = ({commit, dispatch}, payload) => {
  commit(SET_CLASS_USER_FACULT, payload)
}

export default {
  changeSearchClassUserSchool,
  changeSearchClassUserLevel,
  changeSearchClassUserFacult
}



// WEBPACK FOOTER //
// ./src/components/class-users/store/actions.js